import list from "./list.json";
import createDiscount from "./createDiscount.json";
import common from "./common.json";
import buyXGetYDiscount from "./buyXGetYDiscount.json";
import productDiscount from "./productDiscount.json";
import createProductDiscount from "./createProductDiscount.json";
import orderDiscount from "./orderDiscount.json";
import productSearchModal from "./productSearchModal.json";
import productSearchModalAll from "./productSearchModalAll.json";

// One JSON per screen in the Discounts module; this barrel assembles them into the
// single `discounts` i18n namespace. Add a screen by dropping in its JSON and
// adding it here -- src/i18n/index.ts stays untouched.
const discounts = {
  list,
  createDiscount,
  common,
  buyXGetYDiscount,
  productDiscount,
  createProductDiscount,
  orderDiscount,
  productSearchModal,
  productSearchModalAll,
};

export default discounts;
